module.exports = "https://coursera_assets.s3.amazonaws.com/images/518fb0ac09fc8811e54c6a5923e39098.png";